"use client";

import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

export default function EsterVideo() {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
		let hasPlayedOnce = false;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !hasPlayedOnce) {
            video.play().catch(() => {});
						hasPlayedOnce = true
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(video);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <motion.video
      ref={videoRef}
      className="portfolio-video w-full h-full object-cover md:mt-2"
      style={{ width: "300px", height: "auto" }}
      muted={false}
      controls
      preload="metadata"
      playsInline
      controlsList="nodownload noremoteplayback"
      disablePictureInPicture
      poster="/ester/ester_2.png"
    >
      <source src="/ester/ester.webm" type="video/webm" />
      <p className="sr-only">
        Descrição: vídeo de boas vindas da Ester, assistente virtual da Escapa,
        criada para dar vida a tudo o que a marca oferece no mercado de Turismo
        de Luxo assistido.
      </p>
    </motion.video>
  );
}
